// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
import axiosRetry from 'axios-retry';
import VueTheMask from 'vue-the-mask'
import VueMoney from 'v-money'
import iosAlertView from 'vue-ios-alertview';
import mobile from 'mobile-device-detect';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import config from '../static/config/app.js'
import { initializeRouter } from './router' // Importa a função de inicialização

Vue.filter('stripHTML', function (value) {
    const div = document.createElement('div')
    div.innerHTML = value
    return div.textContent || div.innerText || '';
});

const DocumentPersonBrFilter = {
    install(Vue, options) {
        Vue.filter('DocumentPersonBr', (documentId, documentType) => {
            documentId = typeof documentId != 'string' ? documentId.toString() : documentId;
            if (documentType == 'J') {
                documentId = documentId.padStart(14, '0');
                documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            } else {
                documentId = documentId.padStart(11, '0');
                documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            }
            return documentId;
        });
    }
};

const MaskCpf = {
    install(Vue, options) {
        Vue.filter('MaskCpf', (value) => {
            var d = value.split(".");
            value = "***.***." + d[2];
            return value;
        });
    }
};
Vue.use(MaskCpf);

Vue.use(DocumentPersonBrFilter);

Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(iosAlertView)
Vue.use(mobile)
Vue.use(VueAwesomeSwiper)
Vue.use(Autocomplete)
Vue.config.silent = true
Vue.config.productionTip = false
window._app;

axios.interceptors.request.use((cfg) => {
    if (cfg.method == "post" || cfg.method == "put") {
        try {
            cfg.data.dispositivo = window.__app.mobile.osName;
        } catch (err) {
        }
    } else {
        cfg.params = { ...cfg.params, dispositivo: window.__app.mobile.osName }
    }

    return cfg
});

axios.interceptors.request.use((cfg) => {
    if (cfg.baseURL == config.url && window.__app.logged && cfg.authentication) {

        if (cfg.method == "post" || cfg.method == "put") {
            cfg.data._cod = window.__app.user.cod;
            cfg.data._token = window.__app.user.token;
        } else if (cfg.method == "get" || cfg.method == "delete") {
            cfg.params._cod = window.__app.user.cod;
            cfg.params._token = window.__app.user.token;
        }
    }

    return cfg;
});

axios.defaults.baseURL = config.url;
// axios.defaults.baseURL = url;
if (!window.cordova && location.hostname != "localhost") {
    window.console.log = function () { };
}
if (window.cordova || location.hostname != "localhost") {
}
axios.defaults.timeout = 30000;

axiosRetry(axios, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: (response) => {  // custom
        // console.log("retryCondition>", response.code)
        return response.code == 'ECONNABORTED';
    }
});

window.axios = axios;

window.exit = function () {
    console.log("window.exit()")
}

/* eslint-disable no-new */
const startApp = async () => {
    const router = await initializeRouter(); // Inicializa o router após buscar as rotas
    new Vue({
        el: '#app',
        router,
        components: {
            App
        },
        template: '<App/>',

        data: {
            "logged": false,
            "cordova": window.cordova || null,
            "user": {
                "cod": null,
                "token": null,
                "areas": [],
                "tipo": "contratante"
            },
            "menu": {},
            "mobile": mobile,
            "tmp": {
                "financeiroSolicitacoes": null,
                "financeiroSolicitacoesForm": null,
                "pacientesForm": null,
                "dashboardAgendamentos": {
                    "itens": []
                },
                "dashboardMural": {
                    "itens": []
                },
                "pacientes": {
                    "itens": []
                },
                "profissionais": {
                    "itens": []
                },
                "agendamentos": {
                    "itens": []
                },
                "configuracoes": {
                    "tab": null
                }
            },
            "modalAgendarData": null,
            "modal": {
            },
            "sintomas": {
                "etapa": 0
            },
            "chamadaMute": {
                "audio": false,
                "video": false,
            },
            "navCollapsed": true,
            "chamadaRealtime": {},
            "realtime": {},
            "chamada": null,
            "chamadaRoom": null,
            "teleconsulta": null,
            "modalTeleconsulta": false,
            "config": config
        },
        methods: {
            checkPermissao(rota, opcoes = null) {
                console.log("checkPermissao()", rota, opcoes);
                // Processamento das rotas
                let permitir = false;
                let rotaObj = null;
                this.config.rotas.forEach(item => {
                    if (rota == item.name) {
                        if (item.meta && item.meta.level) {
                            permitir = (item.meta.level.indexOf(this.user.tipo) !== -1);
                        }
                    }
                });

                // Processamento dos itens de menu
                if (this.config['menu-itens'][this.user.tipo]) {
                    this.config['menu-itens'][this.user.tipo].forEach(item => {
                        if (item.rota == rota) {
                            permitir = true;
                            rotaObj = item;
                        }
                    });
                }

                if (opcoes) {
                    if (rotaObj.opcoes[opcoes]) {
                        permitir = true;
                    } else {
                        permitir = false;
                    }
                }

                return permitir;                
            },
            checkCondicao(item) {
                return eval(item);
            },
            openChat() {
                if ($(".chat-button")[0]) {
                    $(".chat-button").click();
                } else if ($(".chat-header button")[0]) {
                    $(".chat-header button").click();
                }
            },
            onClick(script) {
                eval(script);
            },                     
            getConfig: function (force) {
                var self = this;
                console.log("getConfig()");
                return new Promise(function (resolve, reject) {

                    var form = {
                        "params": {
                            "_cod": self.user.cod,
                            "_token": self.user.token,
                            "multiplo": true,
                            "nome": "termos-de-uso,politicas-de-privacidade,menu,identidade-visual,mural-recados,menu-itens,rotas"
                        }
                    };

                    axios.get("api/itens.php", form)
                        .then(response => {

                            console.log("getConfig() response", response);
                            var reload = false;
                            if (!window.localStorage.getItem("_config")) {
                                reload = true;
                            }

                            window.localStorage.setItem("_config", JSON.stringify(response.data.result.itens));

                            response.data.result.itens.forEach(function (item) {
                                if (item.nome == "menu") {

                                    var tipos = ["controladoria", "coordenador", "gerente", "marketing", "paciente", "profissional", "profissional-geral"];

                                    var diff = false;
                                    if (JSON.stringify(item.objeto) != JSON.stringify(self.config["menu"])) {
                                        diff = true;
                                    }

                                    tipos.forEach(function (item2) {
                                        if (!item.objeto[item2]) {
                                            item.objeto[item2] = {};
                                        }
                                    });

                                    self.config[item.nome] = item.objeto;
                                    self.$forceUpdate();
                                    setTimeout(function () {
                                        self.$forceUpdate();
                                        setTimeout(function () {
                                            if (diff) {
                                                if (window.mmenuInit) window.mmenuInit(true);
                                            }
                                        }, 100);
                                    }, 100);
                                } else {
                                    self.config[item.nome] = item.objeto;
                                    self.$forceUpdate();
                                }
                            });

                            if (reload) {
                                window.location.reload();
                            }

                            resolve(response.data.result);

                        })
                        .catch(error => {
                            console.log("getConfig() error", error);
                            reject(error);

                        });
                });
            },
            initialize: function () {
                console.log("app.initialize()");
                var self = this;

                gtag('js', new Date());
                gtag('config', self.config.googleAnalytics.id);

                function cloneFunction(fn) {
                    let fnStr = fn.toString();
                    let fnClone = new Function('return ' + fnStr);
                    return fnClone();
                }

                window.confirmWeb = cloneFunction("window.confirm");
                setTimeout(function () {
                    window.confirm = function (msg, callback) {
                        if (window.confirmWeb(msg)) {
                            callback();
                        }
                    }
                }, 500);

                window.alert = function (msg) {
                    window.__app.$iosAlert(msg);
                };

                // window.confirm = function(msg, callback) {

                // }

                // window.prompt   = function(msg, input = null, callback) {
                //     window.__app.$iosAlertView({
                //         "title":    msg,
                //         "input":    true,
                //         "buttons":  [
                //             {
                //                 text: 'Cancelar',
                //                 bold: true,
                //                 onClick: function(data){

                //                 }
                //             },
                //             {
                //                 text: 'Confirmar',
                //                 bold: true,
                //                 onClick: function(data){
                //                     console.log("SIM", data)
                //                     callback(data);
                //                 }
                //             }
                //         ]
                //     });
                // }

                var self = this;
                window.__app = self;
                document.addEventListener('deviceready', this.onDeviceReady.bind(this), false);
                var login = self.checkLogin();

                if (!window.cordova) {
                    $("html").addClass("webapp");
                }

                self.fixClass();
            },
            exit: function () {
                var self = this;
                console.log("exit()")
                window.exit = self.exit;

                $(".mm-menu").hide();
                $("#mm-blocker").hide();
                loading.show();
                window.localStorage.clear();

                setTimeout(function () {
                    if (window.cordova) {
                        window.navigator.app.exitApp();
                    } else {
                        window.location.reload();
                    }
                }, 1000);
            },
            scrollTop: function () {
                setTimeout(function () {
                    $(".dashboard-content-inner")[0].scrollTo({
                        top: 0
                    });
                }, 100);
            },
            atualizarPushToken: function () {
                console.log("push > atualizarPushToken()")
                var self = this;
                if (self.logged && window.localStorage.pushToken) {
                    axios.post("api/push-notification.php", {
                        "_cod": self.user.cod,
                        "_token": self.user.token,
                        "dispositivo": self.mobile.osName,
                        "pushToken": localStorage.getItem('pushToken')
                    })
                        .then(response => {
                            window.localStorage.setItem("pushTokenSalvo", new Date());
                            console.log("push > Salvou push", response)
                        })
                        .catch(error => {
                            console.log("push > Erro:", error)
                        });
                }
            },
            checkPushNotificationPermission: function (requested) {
                var self = this;
                window.FirebasePlugin.hasPermission(function (hasPermission) {
                    if (hasPermission) {
                        console.log("push > Remote notifications permission granted");
                        self.getPushNotificationToken();
                    } else if (!requested) {
                        console.log("push > Requesting remote notifications permission");
                        window.FirebasePlugin.grantPermission(self.checkPushNotificationPermission.bind(this, true));
                    } else {
                        console.log("push > Notifications won't be shown as permission is denied");
                    }
                });
            },
            getPushNotificationToken: function () {
                var self = this;
                window.FirebasePlugin.getToken(function (token) {
                    console.log("push > Got FCM token: " + token);
                    localStorage.setItem('pushToken', token);
                    self.atualizarPushToken();
                }, function (error) {
                    console.log("push > Failed to get FCM token", error);
                });
            },
            go: function (route, data) {
                console.log("app.go()", route, data)
                var self = this;
                if (!data) {
                    data = {};
                } else {
                    data = JSON.parse(data);
                }
                self.$router.push({
                    name: route,
                    query: data
                }).catch(() => { });
                $("body .overhang").fadeOut(500);
            },
            redirect: function (route) {
                console.log("app.redirect()", route)
                var self = this;
                self.$router.push({
                    path: route
                }).catch(() => { });
                $("body .overhang").fadeOut(500);
            },
            onPushNotification: function (message) {
                console.log("push > onPushNotification()", message);
                var self = this;

                if (self.mobile.osName == "iOS") {
                    if (message.messageType == "notification" && message.aps) {
                        if (message.aps.alert) {
                            message.title = message.aps.alert.title;
                            message.body = message.aps.alert.body;
                        }
                    }
                }

                if (message.messageType == "notification" && message.tap && message.link) {
                    window.open(message.link, "_system");
                    return false;
                }

                if (message.messageType == "notification" && message.tap && message.route) {
                    self.go(message.route, message.query || null);
                }

                if (message.messageType == "notification" && message.title && message.body) {

                    if (message.route) {
                        if (message.route == self.$route.name) {
                            return false;
                        }
                    }

                    window.ultimoPush = message;
                    var link = "";
                    if (message.route) {
                        link = "onclick='window.__app.go(\"" + message.route + "\", window.ultimoPush.query)'";
                    } else if (message.link) {
                        link = "onclick='window.open(\"" + message.link + "\", \"_system\")'";
                    }

                    navigator.vibrate(1000);
                    navigator.notification.beep(1);

                    $("body").overhang({
                        custom: true,
                        primary: "#FFFFFF",
                        accent: "#FFFFFF",
                        textColor: "#333333",
                        html: true,
                        message: "<a " + link + "><h4>" + message.title + "</h4><p>" + message.body + "</p></a>",
                        closeConfirm: "true",
                        customClasses: "push-notification",
                        callback: function (selection) {
                            console.log("callback notification", selection)

                        }
                    });

                }

            },
            onDeviceReady: function () {
                console.log("onDeviceReady()")
                var self = this;

                window.open = cordova.InAppBrowser.open;

                if (window.MobileAccessibility) {
                    window.MobileAccessibility.usePreferredTextZoom(false);
                }

                if (window.plugins.preventscreenshot) window.plugins.preventscreenshot.disable(function (result) {
                    // console.log(result); // true - enabled, false - disabled
                }, function (error) {
                    // console.log(error);
                });


                if (self.mobile.isTablet) {
                    window.screen.orientation.lock(window.screen.orientation.type);
                    window.screen.orientation.unlock();
                } else {
                    window.screen.orientation.lock("portrait");
                }

                self.checkPushNotificationPermission();

                window.FirebasePlugin.onMessageReceived(function (message) {
                    console.log("push > onMessageReceived", message);
                    try {
                        console.log(message);
                        self.onPushNotification(message);
                    } catch (e) {
                        console.log("push > Exception in onMessageReceived callback: " + e.message);
                    }

                }, function (error) {
                    console.log("push > Failed receiving window.FirebasePlugin message", error);
                });

                window.FirebasePlugin.onTokenRefresh(function (token) {
                    console.log("push > Token refreshed: " + token)
                    window.localStorage.setItem("pushToken", token);

                }, function (error) {
                    console.log("push > Failed to refresh token", error);
                });


                self.backbutton = function (e) {
                    console.log("backbutton", e)
                    e.preventDefault();

                    if (window.backFn) window.backFn();

                    self.back();
                    return false;
                }

                document.addEventListener('backbutton', self.backbutton, false);

                window.alert = function (msg) {
                    navigator.notification.alert(msg, function () { }, "", "Ok");
                };

                window.confirm = function (msg, callback) {
                    navigator.notification.confirm(msg, function (i) {
                        if (i == 1) {
                            callback();
                        }
                    }, "", ['Sim', 'Cancelar']);
                };

            },
            setUser: function (usuario) {
                var self = this;
                return new Promise(function (resolve, reject) {
                    window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                    self.logged = true;
                    self.user = usuario;
                    resolve(usuario);

                });
            },
            addLog: function (obj) {
                var self = this;
                console.log("addLog()", obj);
                return new Promise(function (resolve, reject) {

                    var form = {
                        "_cod": window.__app.user.cod,
                        "_token": window.__app.user.token,
                        "acao": obj.acao ? obj.acao : "",
                        "pessoaFisicaCod": obj.pessoaFisicaCod ? obj.pessoaFisicaCod : "",
                        "pessoaFisicaNome": obj.pessoaFisicaNome ? obj.pessoaFisicaNome : "",
                        "referenciaCod": obj.referenciaCod ? obj.referenciaCod : "",
                        "descricao": obj.descricao ? obj.descricao : "",
                        "dispositivo": window.__app.mobile.osName,
                    };

                    axios.post("api/logs.php", form)
                        .then(response => {

                            console.log("addlog() response", response.data.result)
                            resolve(response);

                        })
                        .catch(error => {
                            console.log("addlog() error", error)
                            reject(error);
                            alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        });
                });
            },
            getUser: function (force) {
                var self = this;
                console.log("getUser()");
                return new Promise(function (resolve, reject) {

                    var form = {
                        "params": {
                        },
                        authentication: true
                    };

                    axios.get("api/usuarios.php", form)
                        .then(response => {

                            console.log("getUser() response", response);
                            self.setUser(response.data.result);


                            if (response.data.result.termos == 0 || response.data.result.politicas == 0) {

                                console.log("Termos ou politicas pendente");

                                window.termos = {
                                    aceitar: function () {
                                        var self = this;
                                        console.log("aceitarTermos");

                                        var form = {
                                            "_cod": window.__app.user.cod,
                                            "_token": window.__app.user.token,
                                            "acao": window.termos.acao,
                                            "dispositivo": window.__app.mobile.osName,
                                            "campo": window.termos.campo
                                        };

                                        console.log("form", form);

                                        loading.show();

                                        axios.post("api/logs.php", form)
                                            .then(response => {

                                                console.log("response", response.data.result)
                                                if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
                                                if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();
                                                window.__app.getUser().finally(function () {
                                                    loading.hide();
                                                });


                                            })
                                            .catch(error => {
                                                loading.hide();
                                                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                                            });

                                    },
                                    negar: function () {
                                        var self = this;
                                        console.log("negarTermos");


                                        if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
                                        if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();

                                        alert("Para continuar usando o aplicativo é necessário aceitar os termos apresentados. Você será deslogado..");
                                        window.__app.logout();
                                    }
                                };

                                if (response.data.result.termos == 0) {
                                    window.termos.campo = "termos";
                                    window.termos.acao = "ACEITAR_TERMOS_DE_USO";

                                    self.$root.openModal('modal-termos-de-uso', null, true);
                                } else if (response.data.result.politicas == 0) {
                                    window.termos.campo = "politicas";
                                    window.termos.acao = "ACEITAR_POLITICAS_DE_PRIVACIDADE";

                                    self.$root.openModal('modal-politicas-de-privacidade', null, true);
                                }
                            }

                            resolve(response.data.result);

                        })
                        .catch(error => {
                            console.log("getUser() error", error);
                            if (error.response) {
                                if (error.response.status == 404) {
                                    self.logout();
                                }
                            }

                            reject(error);

                        });
                });
            },
            checkLogin: function () {
                var self = this;
                self.getConfig();
                if (!window.localStorage.getItem("_usuario")) {
                    return false;
                } else {
                    var usuario = null;
                    try {
                        usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                        self.setUser(usuario);
                        self.getUser();
                        return true;
                    } catch (err) {
                        console.log("checkLogin() error parse", err);
                        return false;
                    }
                }
            },
            logout: function () {
                var self = this;
                $(".mm-menu").hide();
                $("#mm-blocker").hide();
                loading.show();
                window.localStorage.clear();
                self.go("Login", JSON.stringify({ "reload": true }));
                // location.href="#/login";
                // location.reload();
            },
            back: function () {
                var self = this;
                console.log("back()", self, window.history.length);
                if ($(".tingle-modal--visible")[0]) {
                    $(".tingle-modal--visible").hide();
                    $(".tingle-modal").removeClass("tingle-modal--visible");
                    // console.log("back -> Esconde modal")
                } else {

                    if (window.__app.$route.name == "Dashboard") {
                        window.navigator.app.exitApp();
                        return;
                    }

                    loading.show();
                    if (window.history.length > 2) {
                        // $(".content-load .dashboard-container").fadeOut(100);
                    }

                    if (window.history.length <= 2) {
                        self.go("Dashboard");
                    } else {
                        // window.history.back();
                        self.$router.back();
                    }
                }
            },
            fixClass: function () {
                var self = this;
                if (self.$route) {
                    $("body").attr("class", "");
                    $("body").addClass("current-page-" + (self.$route.name ? self.$route.name.toLowerCase() : null));
                }
            },
            addEvents: function () {
                var self = this;
                $("body").on("click", "a[target='_blank']", function (e) {
                    console.log("open InAppBrowser", e.currentTarget.href, e);
                    if (window.cordova) {
                        e.preventDefault();
                        window.open = cordova.InAppBrowser.open;
                        window.open(e.currentTarget.href, "_system");
                    }

                });
            },

            openModal: function (nome, html, termos) {
                var self = this;

                console.log("openModal()", nome)

                self.modal[nome] = new tingle.modal({
                    footer: false,
                    stickyFooter: false,
                    closeMethods: ['', '', ''],
                    closeLabel: "",
                    cssClass: [(nome), "modal-default"]
                });
                setTimeout(function () {
                    if (!html) {
                        self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);
                    } else {
                        self.modal[nome].setContent(html);
                    }
                    self.modal[nome].open();
                    loading.hide();
                    setTimeout(function () {
                        if (!termos) $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i class="las la-times"></i></a>');
                        if (termos) $("." + nome).append('<div class="termos-button"><button type="button" onclick="window.termos.negar()" class="button red negar-button"><i class="las la-ban"></i> Negar</button><button type="button" onclick="window.termos.aceitar()" class="button green aceitar-button">Aceitar<i class="las la-arrow-right"></i></button></div>');
                    }, 100);
                }, 100);


            },
            modalAgendarSubmit: function () {
                var self = this;
                console.log("modalAgendarSubmit()", self.modalAgendarData);

                var form = {
                    "_cod": self.user.cod,
                    "_token": self.user.token,
                    "HR_INICIO": self.modalAgendarData.agendamento.HR_INICIO,
                    "CD_AGENDA": self.modalAgendarData.agendamento.CD_AGENDA,
                    "NR_SEQUENCIA": self.modalAgendarData.agendamento.NR_SEQUENCIA,
                    "CD_MEDICO_AGENDA": self.modalAgendarData.agendamento.CD_MEDICO_AGENDA,
                }

                loading.show();

                axios.post("api/agendamento.php", form)
                    .then(response => {

                        console.log("ok", response.data.result)
                        loading.hide();
                        alert(response.data.message);
                        if (response.data.result) {
                            self.modalAgendar.close();
                            self.go("Dashboard");
                        }

                    })
                    .catch(error => {
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });
            },
            openSintomas: function () {
                var self = this;
                console.log("openSintomas()");

                loading.show();
                var form = {
                    "params": {
                        "_cod": self.user.cod,
                        "_token": self.user.token,
                        "multiplo": true,
                        "nome": "sintomas"
                    }
                };

                axios.get("api/itens.php", form)
                    .then(response => {

                        console.log("get sintomas response", response);
                        response.data.result.itens.forEach(function (item) {
                            self.config[item.nome] = item.objeto;
                        });

                        self.config.sintomas.etapa = 0;
                        self.$forceUpdate();
                        self.$forceUpdate();
                        setTimeout(function () {
                            self.openModal('modal-sintomas');
                            loading.hide();
                            window.localStorage.removeItem("popup-sintomas");
                        }, 500);

                    })
                    .catch(error => {
                        console.log("get sintomas error", error);
                        loading.hide();

                    });
            },
            enviarSintomas: function (el) {
                var self = this;
                console.log("enviarSintomas()", $(el).data());

                var index1 = $(el).data("index");
                var index2 = $(el).data("index2");

                var pergunta = self.config.sintomas.itens[index1];
                var resposta = self.config.sintomas.itens[index1].itens[index2];

                console.log("Pergunta:", pergunta);
                console.log("Resposta:", resposta);

                var form = {
                    "_cod": self.user.cod,
                    "_token": self.user.token,
                    "nome": "sintomas-diario",
                    "objeto": {
                        "index1": index1,
                        "index2": index2,
                        "pergunta": pergunta.texto,
                        "resposta": resposta.texto,
                        "data": (new Date().toISOString().split("T")[0])
                    }
                }

                console.log("enviarSintomas form:", form);

                loading.show();

                axios.put("api/itens.php", form)
                    .then(response => {

                        console.log("ok", response.data.result)

                        if ((self.sintomas.etapa + 1) < (self.config.sintomas.itens.length)) {
                            self.sintomas.etapa = self.sintomas.etapa + 1;
                        } else {
                            self.modal["modal-sintomas"].close();
                            loading.hide();
                            self.go("Dashboard");
                            alert("Obrigado! Parabéns por compartilhar como você está se sentindo..");
                            return false;
                        }
                        self.$forceUpdate();

                        setTimeout(function () {
                            var html = document.querySelector('#modal-sintomas').innerHTML;
                            // var html = $("#modal-sintomas").html();
                            self.modal["modal-sintomas"].setContent(html);
                            console.log("Setou conteudo", self.modal["modal-sintomas"])
                            loading.hide();
                        }, 500);

                    })
                    .catch(error => {
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });

            },
            openLink: function (url) {
                console.log("openLink", url)
                window.open(url, "_system", "location=yes,hideurlbar=yes,hidenavigationbuttons=yes");
            },
            setTeleconsulta: function (obj) {
                var self = this;
                console.log("setTeleconsulta()", obj);
                self.teleconsulta = obj;
                self.$forceUpdate();
                if (obj.TELECONSULTA.objeto.status == 3 && self.chamada) {
                    console.log("Fim teleconsulta")
                    self.closeChamada();
                }
            },
            closeChamada: function () {
                var self = this;
                console.log("closeChamada()");
                if (window.__track) window.__track.stop();
                if (window.__room) window.__room.disconnect();

                $("#remote-media").html("");
                $("#local-media").html("");

                self.chamada = null;
                self.realtime.client.disconnect();
                self.realtime = {};
                self.$forceUpdate();
                self.setModalTeleconsulta(false);
                if (window.twiliovideo) window.twiliovideo.closeRoom();
            },
            initRealTime: function (NR_SEQUENCIA) {
                var self = this;
                console.log("initRealtime()", NR_SEQUENCIA);
                Pusher.logToConsole = true;
                if (!self.realtime.client) {
                    self.realtime.client = new Pusher(self.config.pusher.key, {
                        cluster: 'us2',
                        activityTimeout: 2000,
                        // enabledTransports: ['ws']
                    });
                }
                self.realtime.channel = self.realtime.client.subscribe("consulta-" + NR_SEQUENCIA);
                self.realtime.channel.bind("update", function (data) {
                    if (data.consulta) {
                        self.setTeleconsulta(data.consulta);
                    }
                });
                self.realtime.channel = self.realtime.client.subscribe("chamada-" + NR_SEQUENCIA + "-" + self.user.cod);
                self.realtime.channel.bind("update", function (data) {
                    if (data.tipo == "token") {
                        self.initChamada(data.token, data.room);
                    }
                    if (data.tipo == "fim") {
                    }
                });
            },
            iniciarChamada: function (chamada) {
                var self = this;
                console.log("iniciarChamada()", chamada)

                self.setTeleconsulta(chamada);
                var NR_SEQUENCIA = chamada.NR_SEQUENCIA;

                loading.show();

                if (self.chamada) {
                    self.closeChamada();
                }

                setTimeout(function () {

                    if (!self.realtime.client) {
                        self.initRealTime(NR_SEQUENCIA);
                    }

                    loading.show();
                    var form = {
                        "NR_SEQUENCIA": NR_SEQUENCIA,
                        "acao": "iniciar"
                    }

                    axios.put("api/teleconsulta.php", form, { "authentication": true })
                        .then(response => {

                            console.log("iniciarChamada()", "success", response.data)
                            loading.hide();
                            // alert(response.data.message);

                        })
                        .catch(error => {

                            console.log("iniciarChamada()", "error", error.data)
                            loading.hide();
                            alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                        });

                }, 1500);
            },
            finalizarChamada: function (NR_SEQUENCIA) {
                var self = this;
                console.log("finalizarChamada()", NR_SEQUENCIA)
                loading.show();
                var form = {
                    "NR_SEQUENCIA": NR_SEQUENCIA,
                    "acao": "finalizar"
                }

                axios.put("api/teleconsulta.php", form, { "authentication": true })
                    .then(response => {

                        console.log("finalizar()", "success", response.data)
                        loading.hide();
                        alert(response.data.message);

                    })
                    .catch(error => {

                        console.log("finalizar()", "error", error.data)
                        loading.hide();
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));

                    });
            },
            openChamada: function () {
                console.log("openChamada()");
                var self = this;
                window.twiliovideo.openRoom(self.chamada.token, self.chamada.room, function (e) {
                    console.log("initChamada() -> onEvent()", e);
                }, {
                    "primaryColor": "#00bcb4",
                    "secondaryColor": "#00bcb4",
                    "handleErrorInApp": true
                });
            },
            checkPermissionsChamada: function () {
                console.log("checkPermissionsChamada()");
                if (window.device) {
                    if (window.device.platform === "Android") {
                        window.cordova.plugins.permissions.requestPermissions([window.cordova.plugins.permissions.CAMERA, window.cordova.plugins.permissions.RECORD_AUDIO, window.cordova.plugins.permissions.MODIFY_AUDIO_SETTINGS]);
                    }
                }
                if (window.cordova && window.cordova.plugins && window.cordova.plugins.backgroundMode) {
                    window.cordova.plugins.backgroundMode.enable();
                }
            },
            setModalTeleconsulta(status) {
                console.log("setModalTeleconsulta()", status);
                this.modalTeleconsulta = status;
                this.$forceUpdate();
            },
            initChamada: function (token, room) {
                var self = this;
                console.log("initChamada()", token, room);

                self.chamada = {
                    "token": token,
                    "room": room
                };

                self.$forceUpdate();

                window.__chamada = self.chamada;

                if (!window.device) window.device = {};
                if (window.device.platform == "iOS" || window.device.platform == "Android") {

                    self.openChamada();
                    return false;
                }
                self.modalTeleconsulta = "opened";
                self.$forceUpdate();

                setTimeout(function () {
                    $(".modal-teleconsulta").draggable();
                }, 500);

                $(".dashboard-content-inner")[0].scrollTo({
                    top: $(".dashboard-content-inner").height()
                });

                var Video = Twilio.Video;
                Video.createLocalVideoTrack().then(track => {
                    var localMediaContainer = document.getElementById('local-media');
                    window.__track = track;
                    localMediaContainer.appendChild(track.attach());
                });

                Video.connect(token, {
                    name: room,
                    bundlePolicy: 'max-compat'
                }).then(room => {
                    console.log(`Successfully joined a Room: ${room}`);

                    loading.hide();

                    self.chamadaRoom = room;
                    window.__room = room;
                    // _room       = room;

                    var remoteMediaContainer = document.getElementById('remote-media');
                    room.participants.forEach(function (participant) {
                        console.log("Already in Room: '" + participant.identity + "'");
                        participantConnected(participant, remoteMediaContainer);
                    });

                    room.on('participantConnected', participant => {
                        console.log(`A remote Participant connected: ${participant}`);
                        participantConnected(participant);
                    });

                    room.on('participantDisconnected', participant => {
                        console.log(`A remote Participant connected: ${participant}`);
                        participantDisconnected(participant);
                    });

                }, error => {
                    loading.hide();
                    console.error(`Unable to connect to Room: ${error.message}`);
                });

                function participantConnected(participant) {
                    console.log('Participant "%s" connected', participant.identity);
                    const div = document.createElement('div');
                    div.id = participant.sid;
                    participant.on('trackSubscribed', (track) => {
                        trackSubscribed(div, track)
                    });
                    participant.on('trackUnsubscribed', trackUnsubscribed);
                    participant.tracks.forEach(publication => {
                        if (publication.isSubscribed) {
                            trackSubscribed(div, publication.track);
                        }
                    });

                    document.getElementById('remote-media').appendChild(div);
                }

                function participantDisconnected(participant) {
                    console.log('Participant "%s" disconnected', participant.identity);

                    var div = document.getElementById(participant.sid)
                    if (div) {
                        div.remove();
                    }
                }

                function trackSubscribed(div, track) {
                    div.appendChild(track.attach());
                }

                function trackUnsubscribed(track) {
                    track.detach().forEach(element => element.remove());
                }

            },
            muteAudio: function () {
                var self = this;
                if (!self.chamadaMute.audio) {
                    self.chamadaRoom.localParticipant.audioTracks.forEach((publication) => {
                        publication.track.disable();
                    });
                    self.chamadaMute.audio = true;
                } else {
                    self.chamadaRoom.localParticipant.audioTracks.forEach((publication) => {
                        publication.track.enable();
                    });
                    self.chamadaMute.audio = false;
                }
                self.$forceUpdate();
            },
            muteVideo: function () {
                var self = this;
                if (!self.chamadaMute.video) {
                    self.chamadaRoom.localParticipant.videoTracks.forEach((publication) => {
                        publication.track.disable();
                    });
                    self.chamadaMute.video = true;
                } else {
                    self.chamadaRoom.localParticipant.videoTracks.forEach((publication) => {
                        publication.track.enable();
                    });
                    self.chamadaMute.video = false;
                }
                self.$forceUpdate();
            },
            toggleNavCollapsed: function () {
                var self = this;
                self.$root.navCollapsed = !self.$root.navCollapsed;
            }
        },
        created: function () {
            var self = this;
            if (!window.localStorage.getItem("_intro") && self.mobile.isMobile && self.$route.name != "RecuperarSenha" && self.$route.name != "ConfirmarAgendamento" && self.$route.name != "CompletarCadastro" && self.$route.name != "LoginApp" && self.$route.name != "Login") {
                self.go("Introducao");
            }

            if (window.localStorage.getItem("_config")) {
                var cfg = JSON.parse(window.localStorage.getItem("_config"));
                cfg.forEach(function (item) {
                    if (item.nome == "menu") {
                        var diff = false;
                        if (JSON.stringify(item.objeto) != JSON.stringify(self.config["menu"])) {
                            diff = true;
                        }
                        self.config[item.nome] = item.objeto;
                        self.$forceUpdate();
                        setTimeout(function () {
                            self.$forceUpdate();
                            setTimeout(function () {
                                if (diff) {
                                    if (window.mmenuInit) window.mmenuInit(true);
                                }
                            }, 100);
                        }, 100);
                    } else {
                        self.config[item.nome] = item.objeto;

                    }
                });
                if (!self.config['mural-recados']) {
                    self.config['mural-recados'] = {};
                }
            }

            self.cordova = window.cordova;

            self.initialize();
            loading.show();
            self.addEvents();
        },
        mounted: function () {
            console.log("mounted geral >>", this);
            var self = this;
            setTimeout(function () {
                $("#wrapper").fadeIn(1000);
            }, 1000);
        },
        watch: {
            $route(to, from) {
                var self = this;
                self.fixClass();

                console.log("route changed>", to, from)

                if (from.name == "Formulario") {
                    window.removeEventListener("onmessage", window._onMessage, false);
                    window.removeEventListener("message", window._onMessage, false);
                }

                if (from.name == "CadastrarCampanhasFiltros" || from.name == "EditarCampanhasFiltros") {
                    if (to.name != "Configuracoes") {
                        self.tmp.configuracoes.tab = "";
                        self.$forceUpdate();
                    }
                } else if (from.name == "Configuracoes") {
                } else {
                    self.tmp.configuracoes.tab = "";
                    self.$forceUpdate();
                }

                setTimeout(function () {
                    if (window.fixHeight) window.fixHeight();
                    window.scrollTo({
                        top: 0
                    });
                    if (window.mmenuInit) window.mmenuInit();
                    gtag('config', self.config.googleAnalytics.id, { 'page_title': to.meta.title });
                }, 100);
            }
        },
        on: {
        }
    });
}

startApp(); // Chama a função para inicializar a aplicação Vue


// WEBPACK FOOTER //
// ./src/main.js